module.exports = __webpack_public_path__ + "static/media/bleached_oak.0f98a3b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interiorColors/bleached_oak.jpg
// module id = 638
// module chunks = 0